
import { Vue, Component } from 'vue-property-decorator';
import { getOnlineList } from '../api';
import { isWeiXin } from '@/common/ts/common';
import { List, Toast } from 'vant';
import qs from 'qs';

Vue.use(List).use(Toast);
@Component
export default class Home extends Vue {
  list: any[] = [];
  page = 1;
  loading = false;
  finished = false;
  show: boolean = true;
  unionid: string | null = '';

  created () {
    this.goMiNi();
  }

  goMiNi() {
    // this.$router.push('empty');
    window.location.href = 'https://appwxsmad5a1601.h5.xiaoeknow.com/p/decorate/page/eyJpZCI6NDA4NjYzMCwiY2hhbm5lbF9pZCI6IiJ9?share_user_id=u_636672bca5c44_BkjBsWTTph&share_type=5&wework_share_customer_id=u_636672bca5c44_BkjBsWTTph&entry=2&entry_type=2002';
  }
  setMsg() {
    const token = window.gettoken();
    if (!token && window.udid) {
      this.AppLogin();
    } else if (!window.udid) {
      Toast('请在上游APP中打开留言');
      return false;
    }

    this.$router.push('messageLeave');
  }
  onLoad() {
    getOnlineList(this.page).then((res: any) => {
      this.endListData(res);
    });
  }
  endListData(res: any) {
    this.page = this.page + 1;
    this.finished = true;
    if (!res.data || res.data.length === 0) {
      this.finished = true;
    } else {
      this.list = [...this.list, ...res.data];
    }
    this.loading = false;
  }
  reset() {
    this.list = [];
    this.page = 1;
    this.loading = false;
    this.finished = false;
    this.show = false;
    setTimeout(() => {
      this.show = true;
    }, 50);
  }
  AppLogin() {
    const token = window.gettoken();
    if (token === 'null' || !token) {
      if (parseFloat(window.version) >= 4.5) {
        window.handleMessage('{"action":"mUserLogin","data":""}');
      } else {
        window.location.href = 'client:logout';
      }
      return;
    }
  }

  WechatLogin() {
    const { code, source } = qs.parse(location.search, {
      ignoreQueryPrefix: true,
    });
    if (isWeiXin() && !code) {
      const appId = 'wx1949ed4a473b87ed';
      location.href = `https://activity.cqcb.com/wechat-auth.html?appId=${appId}&backUrl=${encodeURIComponent(
        location.href,
      )}`;
    }
  }
}
